import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const accesToken = `Bearer ${localStorage.getItem("access")}`;
export const customerServices = createApi({
  reducerPath: "customerServices",
  tagTypes: ["customer"],
  baseQuery: fetchBaseQuery({ baseUrl: "https://api.upswap.app/api" }),
  endpoints: (builder) => ({
    getAllActivities: builder.query({
      providesTags: ["customer"],
      query: () => ({
        url: "/activities/lists/",
        method: "GET",
      }),
    }),
     getActivityDetails: builder.query({
      providesTags: ["customer"],
      query: (id) => ({
        url: `/activities/details/${id}/`,
        method: "GET",
      }),
    }),
      gettimeslotsProvider : builder.query({
      providesTags: ["customer"],
      query: ({id,date}) => ({
        url: `appointments/get-time-slots/?provider_id=${id}&for_date=${date}`,
        method: "GET",
        headers: {
          Authorization: accesToken,
        },
      }),
    }),
     createChatRequest: builder.mutation({
      query: (newPost) => ({
        url: "/chat/create-chat-request/",
        headers: {
          Authorization: accesToken,
          "Content-Type": "application/json",
        },
        method: "POST",
        body: newPost,
      }),
    }),
    createActivity: builder.mutation({
      query: (newPost) => ({
        url: "/activities/create/",
        headers: {
          Authorization: accesToken,
          "Content-Type": "application/json",
        },
        method: "POST",
        body: newPost,
      }),
    }),

  }),
});

export const {
  useGetAllActivitiesQuery,
  useGetActivityDetailsQuery,
  useGettimeslotsProviderQuery,
  useCreateChatRequestMutation,
  useCreateActivityMutation
} = customerServices;
export default customerServices;